// Filename: public/reportManager.js

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';
import { checkUserMemberShipPlans } from 'public/customAds.js';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';
import { getQuizName } from 'public/surveyManager';
import { customLoginOrSignup } from 'public/customSignUpLogin';

let isPaidMember = false;
let isScrolledThroughReport = false;
export let isShareMyReport = wixLocation.query.shareMyReport;
let isLoginPopupShown = false;
let is50PerScrollNudgeEventSent = false;

export async function reportScrollHandler() {

    $w("#scrolledThroughReport").onViewportEnter((event) => {
        adsOnScrollHandler();
    })

    $w("#showSignUpmodal").onViewportEnter((event) => {
        halfReportScrollHandler();
    });
}

async function adsOnScrollHandler() {

    if (!wixUsers.currentUser.loggedIn) {
        return;
    }

    if (!isShareMyReport && !isScrolledThroughReport) {
        isScrolledThroughReport = true;
        isPaidMember = await checkUserMemberShipPlans();
        console.log('isPaidMember:-', isPaidMember);
        if (!isPaidMember) {
            let currentQuizName = await getQuizName();
            const clevertapJson = {
                "QuizName": currentQuizName
            };
            saveCleverTapEvent('Ads Scrolled through Report', clevertapJson);
            spentTimeOnReportCTEvent();
        }
    }
}

async function spentTimeOnReportCTEvent() {
    if (wixLocation.query.minimal !== "yes") {
        wixWindow.openLightbox("Reports Interference Ads");
        setInterval(() => {
            wixWindow.openLightbox("Reports Interference Ads");
        }, 5 * 60 * 1000);
    } else {
        saveCleverTapEvent('Ads Spent time on Report', {});
        setInterval(() => {
            saveCleverTapEvent('Ads Spent time on Report', {});
        }, 5 * 60 * 1000);
    }
}

export async function halfReportScrollHandler() {
    console.log('50% scrolled onViewportEnter ....');
    if (!wixUsers.currentUser.loggedIn && !isShareMyReport && !isLoginPopupShown && wixLocation.query.minimal !== "yes") {
        const dataToSend = {
            value: "Half Scrolled Through Report Nudge",
            //ctEventName: "Half Scrolled Through Report Nudge",
            title: "Enjoying your report?",
            description: "Create a free account to save it and view your insights anytime.",
            yesBtnText: "Yes, Save My Report",
            noBtnText: "No, I'll Just Keep Reading",
            imgURL: "https://static.wixstatic.com/media/de4f7d_d2359bacb1cf44dda2384573ef89d837~mv2.jpg",
        }
        wixWindow.openLightbox('Nudge Message', dataToSend).then((rDataFromPopup) => {
            isLoginPopupShown = true;
            console.log('Nudge Mesage lightbox closed...');
            if (rDataFromPopup && rDataFromPopup.toOpen === "signUpForm") {
                customLoginOrSignup('signup');
            }
        })
    } else if (!wixUsers.currentUser.loggedIn && wixLocation.query.minimal === "yes" && !is50PerScrollNudgeEventSent){
        console.log('I am mobile app page');
        saveCleverTapEvent('Half Scrolled Through Report Nudge', {});
        is50PerScrollNudgeEventSent = true;
    }
}

export function reportGenNudgeMessage() {
    const dataToSend = {
        value: "Report Gen Nudge Message",
        //ctEventName: "Report Gen Nudge Message",
        title: "Hang tight!",
        description: "Your report is on the way. Signing up now helps keep it safe and ready for whenever you need it.",
        yesBtnText: "Yes, Save My Results ",
        noBtnText: "No, Just Show My Report ",
        imgURL: "https://static.wixstatic.com/media/de4f7d_fc0ff5ef25b1494b8651737fc11f13e0~mv2.jpg",
    }
    wixWindow.openLightbox('Nudge Message', dataToSend).then((rDataFromPopup) => {
        if (rDataFromPopup && rDataFromPopup.toOpen === "signUpForm") {
            customLoginOrSignup('signup');
        }
    })
}